import { render, staticRenderFns } from "./SignMessageContainer.vue?vue&type=template&id=0f09898c&scoped=true&"
import script from "./SignMessageContainer.vue?vue&type=script&lang=js&"
export * from "./SignMessageContainer.vue?vue&type=script&lang=js&"
import style0 from "./SignMessageContainer.vue?vue&type=style&index=0&id=0f09898c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f09898c",
  null
  
)

export default component.exports